/**
 * "codeBu", "PRICE GROUP", "Buttoning Tab" and "ready_for_production" all
 * become "code-bu", "price-group", "buttoning-tab", "ready-for-production".
 */
export const kebabCase = (value: string): string =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
